import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import { createApiWithPath } from "../../client";
import {
  ProfileFieldsResponse,
  ProfileFieldValue,
} from "../../types/crm/profile-fields";

export const fetchProfileFields = async (
  profileId: string,
): Promise<ProfileFieldsResponse> => {
  const { data } = await createApiWithPath("crm").get<{
    data: ProfileFieldValue[];
  }>(`/profile/${profileId}/field-values`);
  return { fieldValues: data.data };
};

export const useProfileFields = (
  profileId: string | undefined,
): QueryObserverBaseResult<ProfileFieldsResponse> => {
  const { data, ...props } = useQuery(
    queryKeys.profileFields(profileId),
    () => fetchProfileFields(profileId!),
    {
      enabled: Boolean(profileId),
      onError: (error: any) => {
        console.error("Failed to fetch profile fields:", error);
      },
    },
  );
  return {
    data: data || { fieldValues: [] },
    ...props,
  };
};
